import { render, staticRenderFns } from "./FolderOfferFileDrag.vue?vue&type=template&id=21e8c6e9&scoped=true"
import script from "./FolderOfferFileDrag.vue?vue&type=script&lang=js"
export * from "./FolderOfferFileDrag.vue?vue&type=script&lang=js"
import style0 from "./FolderOfferFileDrag.vue?vue&type=style&index=0&id=21e8c6e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e8c6e9",
  null
  
)

export default component.exports